import React from 'react';
import { Paper, Switch, TableCell, Typography } from 'components/mui';
import styles from './CheckpointEditor.module.css';
import DropdownComponent from './DropdownComponent';

interface CheckpointDropdownResponseProps {
	dropdowns: CheckpointDropdown[];
	responseType: CheckpointResponseTypesTS;
	onUpdateDropdown: (updatedValues: CheckpointDropdown[]) => void;
	onUpdateResponseType: (e: any) => void;
}

const CheckpointDropdownResponse = (props: CheckpointDropdownResponseProps) => {
	const { dropdowns, responseType, onUpdateDropdown, onUpdateResponseType } =
		props;

	return (
		<Paper className={styles.table}>
			<DropdownComponent
				dropdownType={'dropdownResponseOption'}
				dropdowns={dropdowns}
				onUpdateDropdown={onUpdateDropdown}
				headerText="Dropdown Options"
			/>
			<TableCell key="mult-select-header">
				Allow Multiple Selections
			</TableCell>
			<TableCell>
				<Switch
					// change response type to DropdownMultiSelect
					checked={responseType === 'DropdownMultiSelect'}
					color="primary"
					size="medium"
					onChange={(e) => {
						const _updatedResponseType = e.target.checked
							? 'DropdownMultiSelect'
							: 'Dropdown';
						const _event = {
							target: {
								value: _updatedResponseType,
							},
						};
						onUpdateResponseType(_event);
					}}
				/>
			</TableCell>
		</Paper>
	);
};
export default CheckpointDropdownResponse;
